import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import AdBlockerPlusDetector from '@xingternal/ad-blocker-plus-detector';
import { GridContainer } from '@xingternal/xing-grid';
import testable from '@xingternal/malt-util/testable';
import { NSP_CORE } from '@xingternal/malt-constants';
import { SideBar } from '@xingternal/platform-layout-side-bar';
import { HeaderLoggedIn } from '@xingternal/platform-layout-header-logged-in';
import { BottomBar } from '@xingternal/platform-layout-bottom-bar';
import { Footer } from '@xingternal/platform-layout-footer';
import { CenterContainer } from '@xingternal/platform-layout-view-wrapper';
import { SkipNavigation } from '@xingternal/platform-layout-skip-navigation';
import { useMediaListener, BREAKPOINTS } from '@xingternal/util';

import styles from './LayoutMain.css';

const TestableDiv = testable(NSP_CORE, 'div');

const LayoutMain = ({
  children,
  className,
  contentClassName,
  gridClassName,
  helpLink,
  homeLink,
  intl: { locale },
  sidebar,
  testId,
  type,
  withSubNav,
}) => {
  const breakpoint = useMediaListener();
  // Footer should be hidden on Armstrong and mobile
  const isNotHandheld = breakpoint !== BREAKPOINTS.handheld;

  return (
    <TestableDiv className={cx(styles.wrapper, className)} testId={testId}>
      <AdBlockerPlusDetector />
      <SkipNavigation />

      <HeaderLoggedIn
        {...{
          className: cx({ [styles.armstrongHeader]: withSubNav }),
          helpLink,
          homeLink,
        }}
      />

      <CenterContainer
        className={cx(styles.shell, {
          [styles.fullScreenShell]: type === 'fullScreen',
        })}
      >
        {/* Hide sidebar if LoggedOut */}
        <div className={styles.sidebar}>{sidebar || <SideBar />}</div>

        <section className={styles.scrollWrapper}>
          <div className={cx(styles.container, contentClassName)}>
            <main id="content" className={styles.main}>
              <GridContainer className={gridClassName} type={type} withSidenav>
                {children}
              </GridContainer>
            </main>
          </div>
        </section>
      </CenterContainer>

      {isNotHandheld && <Footer locale={locale} homeLink={homeLink} />}

      <div className={styles.bottomBarPlacebo}>
        <BottomBar />
      </div>
    </TestableDiv>
  );
};

LayoutMain.defaultProps = {
  type: 'standard',
  homeLink: '/',
  withSubNav: false,
};

LayoutMain.propTypes = {
  // Intl
  intl: PropTypes.object.isRequired,
  // Props
  className: PropTypes.string,
  children: PropTypes.node,
  contentClassName: PropTypes.string,
  gridClassName: PropTypes.string,
  helpLink: PropTypes.string,
  homeLink: PropTypes.string,
  sidebar: PropTypes.node,
  testId: PropTypes.string,
  type: PropTypes.oneOf(['standard', 'wide']),
  withSubNav: PropTypes.bool,
};

export { LayoutMain };
